import { BRAND_LIST, COUNTRY, CountryEnv } from "@type/index";
import GUHKCountryENV from "../country/GU/HK";
import GUTWCountryENV from "../country/GU/TW";
import UQHKCountryENV from "../country/UQ/HK";
import UQTWCountryENV from "../country/UQ/TW";

export const REACT_APP_BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "";
export const BUILD_VERSION = process.env.BUILD_VERSION || "";
export const LOCALISATION_VERSION = process.env.LOCALISATION_VERSION || "";
export const UQ_UIKIT_VERSION = process.env.UQ_UIKIT_VERSION || "";
export const GU_UIKIT_VERSION = process.env.GU_UIKIT_VERSION || "";

// GU/HK
export const GU_HK_Ios_UserAgent = "MobileApp-iOS";
export const GU_HK_Android_UserAgent = "MobileApp-android";
// UQ/HK
export const UQ_HK_Ios_UserAgent = "iOSApp";
export const UQ_HK_Android_UserAgent = "AndroidApp";
// GU/TW
export const GU_TW_Ios_UserAgent = "GU-MobileApp-iOS";
export const GU_TW_Android_UserAgent = "GU-MobileApp-android";
// UQ/TW
export const UQ_TW_Ios_UserAgent = "UQ-MobileApp-iOS";
export const UQ_TW_Android_UserAgent = "UQ-MobileApp-android";
// Native app
export const FR_UserAgent = "FRNativeApp";
export const MINIMUM_FETCH_INTERVAL = 15 * 60 * 1000; // 15m
export const FETCH_TIMEOUT_MILLIS = 60 * 1000; // default -> 1m
export const TRACK_EVENT = "trackEvent";
export const TRACK_EVENT_SEARCH = "trackEventSearch";

export const SB_ENV = (brand: string, region: string): CountryEnv => {
  switch (`${brand}${region}`) {
    case `${BRAND_LIST.GU}${COUNTRY.HK}`:
      return GUHKCountryENV;
    case `${BRAND_LIST.GU}${COUNTRY.TW}`:
      return GUTWCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.HK}`:
      return UQHKCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.TW}`:
      return UQTWCountryENV;
    default:
      return GUHKCountryENV;
  }
};
